<template>
  <div style="padding:0 5px !important;">
    <div style="position:relative; padding:0px !important; display: flex; align-items: stretch;">
      <div style="max-width: 100%; width:100%;">
          <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" :id="'dropdown_' + id" style="width:100%;justify-content: space-between;display: flex;align-items: center;">
            <span>{{ label.length > 12 ? label.substring(0,12)+"..." : label }}</span>
            <span v-if="multiple && Array.isArray(selected) && selected.length > 1" style="font-size:12px">({{ selected.length }})</span>
          </button>
        <div class="dropdown-menu" :aria-labelledby="'dropdown_' + id"  style="overflow-x:hidden; overflow-y: auto;width:100%; max-height:250px;height:auto;padding:2px 0px !important;top: auto;border-radius:4px">
          <ul
            v-if="multiple"
          >
            <li
              v-for="option in mappedOptions"
              :key="option.id"
              class="checkbox-custom checkbox-primary dropdown-item"
              style="text-align: left"
            >
              <input
                :name="'checkbox_'+ option.id"
                type="checkbox"
                v-model="option.checked"
                @change="toggleMultipleElem(option)"
                :checked="option.checked"
              />
              <label
                class="elem-item-name"
              >
                <span style="white-space: normal"> {{ option.name }} </span>
              </label>
            </li>
          </ul>
          <ul v-else>
            <li
              v-for="option in mappedOptions"
              :key="option.id"
              class="dropdown-item"
              :style="`text-align: left;cursor: pointer; ${option.id === selected ? 'background-color: #eee' : ''}`"
              @click="selected = option.id"
            >
              <label
                class="elem-item-name"
                style="cursor: pointer"
              >
                <span v-if="option.icon" :style="'color:'+option.iconColor">{{option.icon}}</span>
                <span style="white-space: normal"> {{ option.name }} </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "options", "multiple", "defaultSelected", "icon", "iconColor"],
  data() {
    return {
      label: '‎',
      selected: null,
      mappedOptions: []
    };
  },
  mounted() {
    this.selected = this.defaultSelected;
    if(this.multiple) {
      if(!this.selected) {
        this.selected = [];
      }
      this.updateLabelMultiple();
    }else {
      this.updateLabel();
    }
    // checked selected in options
    if(this.multiple) {
      this.mappedOptions = this.options.map((option) => {
        if(this.selected.includes(option.id)) {
          option.checked = true;
        }
        return option;
      });
    }else{
      this.mappedOptions = this.options.map((option) => {
        if(this.selected === option.id) {
          option.checked = true;
        }
        return option;
      });
    }
  },
  methods: {
    updateLabelMultiple(selection) {
      const selected = selection || this.selected;
      if(selected.length === 0 && this.multiple) {
        this.label = '‎';
      }else if(selected.length === 1) {
        this.label = this.options.find((option) => option.id === selected[0]).name;
      }else if(!selected.includes(null)) {
        this.label = this.options.reduce((acc, option) => {
          if (selected.filter((id) => id === option.id).length > 0) {
            acc.push(option.name);
          }
          return acc;
        }, []).join(" + ");
      }
    },
    updateLabel(selection) {
      const selected = selection || this.selected;
      if(!selected) {
        this.label = '‎';
      } else {
        this.label = this.options.find((option) => option.id === selected).name;
      }
    },
    toggleMultipleElem: function (elem) {
      if(elem.checked) {
        this.selected = [...this.selected, elem.id];
      }else{
        this.selected = this.selected.filter((id) => id !== elem.id);
      }
    },
  },
  watch: {
    selected(selected) {
      this.$emit("update:selected", selected);
      if(this.multiple) {
        this.updateLabelMultiple();
      }else {
        this.updateLabel();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// DropdownSelector.vue?e4e045ac